import { render, staticRenderFns } from "./ComplaintIndex.vue?vue&type=template&id=6eb996ee&"
import script from "./ComplaintIndex.vue?vue&type=script&lang=js&"
export * from "./ComplaintIndex.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports